import React from "react";
import "./About.css";

function About() {
  return (
    <div className="about-container">

      <div className="about-hero">
        <h1>About REACH AI</h1>
        <p>
          Rural Educational Advancement for Community Health (REACH) AI is a
          smart health assistance platform designed to empower rural communities
          with accessible, reliable, and AI-powered health and nutrition guidance.
        </p>
      </div>

      <div className="about-section">
        <h2>🌍 Our Mission</h2>
        <p>
          Our mission is to bridge the healthcare information gap in rural and
          underserved regions by leveraging Artificial Intelligence. REACH AI
          provides personalized nutrition plans, symptom-based health guidance,
          and educational wellness resources in a simple and accessible format.
        </p>
      </div>

      <div className="about-section">
        <h2>🤖 What We Offer</h2>
        <ul>
          <li>AI-powered personalized meal plan generation</li>
          <li>Health awareness conversational assistant</li>
          <li>Regional language support (Bengali/Assamese)</li>
          <li>Text-to-Speech accessibility features</li>
          <li>Yoga and nutrition educational libraries</li>
        </ul>
      </div>

      <div className="about-section">
        <h2>🎯 Vision</h2>
        <p>
          We envision a future where every individual, regardless of location,
          has access to reliable health knowledge and preventive care tools.
          REACH AI aims to support community well-being through technology-driven solutions.
        </p>
      </div>

      <div className="about-section">
        <h2>🔐 Privacy & Responsibility</h2>
        <p>
          REACH AI respects user privacy. We do not share personal information
          and aim to provide educational health guidance. The platform does not
          replace professional medical consultation.
        </p>
      </div>

    </div>
  );
}

export default About;